import React, { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { useAuth } from '../../hooks/auth';
import { useToast } from '../../hooks/toast';
import CustomerIntelligenceSection from '../../features/customerIntelligence/components/CustomerIntelligenceSection';
import { Container, Wrapper } from './styles';

const CustomerIntelligence: React.FC = () => {
  const { user, rotinas, findRotinas } = useAuth();
  const { addToast } = useToast();
  const history = useHistory();

  const hasPermission = useCallback(
    (): boolean => findRotinas('painel_controle_detalhes')?.listar || false,
    [findRotinas],
  );

  useEffect(() => {
    if (rotinas && !hasPermission()) {
      addToast({
        type: 'error',
        title: 'Não autorizado.',
        description: 'Você não tem permissão.',
      });
      history.push('/monitor_pedidos');
    }
  }, [addToast, hasPermission, history, rotinas]);

  return (
    <Container>
      <Wrapper>
        <header>
          <h1>Inteligência Comercial</h1>
          <p>Analise o comportamento de compra da empresa autenticada.</p>
        </header>
        <CustomerIntelligenceSection
          companyName={user?.empresa_nome_fantasia}
        />
      </Wrapper>
    </Container>
  );
};

export default CustomerIntelligence;
